import React, {Component} from 'react';
import axios from 'axios';
import LoginItem from "../../components/LoginItem/LoginItem";

class RegisterForm extends Component {

    constructor(props) {
        super(props);
        document.title = 'Registration form';
    }

    state = {
        formData: {
            name: {
                value: '',
                isValid: true,
                message: ''
            },
            email: {
                value: '',
                isValid: true,
                message: ''
            },
            password: {
                value: '',
                isValid: true,
                message: ''
            },
            role: {
                value: 'ROLE_USER',
                isValid: true,
                message: ''
            },

        }
    };

    placeholder = {
        name: "Username",
        email: "Email",
        password: "Password"
    };

    inputChangeHandler = event => {
        const value = event.target.value;
        const fieldName = event.target.name;
        const updatedFormData = {...this.state.formData};

        updatedFormData[fieldName] = {
            value: value,
            isValid: true,
            message: null
        }

        this.setState({formData: updatedFormData})
    };

    validationHandler = error => {
        const responseData = error.response.data;
        const updatedFormData = {...this.state.formData};
        if (responseData !== null) {
            if (responseData.globalError) {
                this.setState({globalMessage: responseData.globalError});
            }
            if (responseData.fieldErrors) {
                for (let fe of responseData.fieldErrors) {
                    updatedFormData[fe.field] = {
                        value: this.state.formData[fe.field].value,
                        isValid: false,
                        message: fe.message
                    }
                }
            }
            this.setState({formData: updatedFormData});
        } else {
            this.setState({globalMessage: error});
        }
    };


    formSubmit = event => {
        event.preventDefault();
        const data = {
            name: this.state.formData.name.value,
            email: this.state.formData.email.value,
            password: this.state.formData.password.value,
            role: this.state.formData.role.value
        };

        axios.post("/api/users/register", data)
            .then(() => {
                this.props.history.push("/login");
            })
            .catch(error => {
                console.warn("error.response: ", error === null ? error.response : error);
                console.log("error.response.data: ", error === null ? error : error);
                this.validationHandler(error);
            });
    }

    render() {


        const bgStyle = {
            //height: "80vh",
            backgroundImage: "url('../assets/img/wallpaper-tumblr-pc-awesome-yukle-1200x851-travel-background-tumblr-pc-most-beautiful-of-wallpaper-tumblr-pc.jpg')",
            marginTop: "-20px",
            backgroundSize: "cover",
            backgroundPosition: "top center"
        };

        return (
            <div className="page-header header-filter"
                 style={bgStyle}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 ml-auto mr-auto">
                            <div className="card card-login">
                                <form className="form" onSubmit={this.formSubmit}>

                                    <h3 className="card-title">Register</h3>

                                    <br/>
                                    <div className="card-body">
                                <span className="bmd-form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="material-icons">face</i>
                                            </span>
                                        </div>
                    <LoginItem
                        label="Username:"
                        type="text"
                        object={this.state.formData.name}
                        name="name"
                        inputChangeHandler={this.inputChangeHandler}
                        placeholder={this.placeholder.name}
                    />

                                        </div>
                                </span>
                                        <span className="bmd-form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="material-icons">email</i>
                                            </span>
                                        </div>

                    <LoginItem
                        label="Email:"
                        type="email"
                        object={this.state.formData.email}
                        name="email"
                        inputChangeHandler={this.inputChangeHandler}
                        placeholder={this.placeholder.email}
                    />
                                        </div>
                                </span>
                                        <span className="bmd-form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="material-icons">lock_outline</i>
                                            </span>
                                        </div>

                    <LoginItem
                        label="Password:"
                        type="password"
                        object={this.state.formData.password}
                        name="password"
                        inputChangeHandler={this.inputChangeHandler}
                        placeholder={this.placeholder.password}
                    />
                    </div>
                                </span>
                                    </div>
                                    <br/>
                                    <br/>
                                    <button type="submit" className="btn btn-primary">Register</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default RegisterForm


// WEBPACK FOOTER //
// ./src/containers/RegisterForm/RegisterForm.jsx